import { Component, EventEmitter, Input, Output } from "@angular/core";

import { Command } from "@tylertech/commands-module";
import { EventEmitterHelper, Utilities } from "@tylertech/shared-module";
import { IInfoTable, IInfoTableCriteria } from "@tylertech/tyler-api-types";
import { Observable } from "rxjs";

import { InfoTableCommandArgs } from "../../interfaces";
import { DeleteRowArgs, EditRowArgs, GetInfoTableOptions, InfoGridRowActionEvent } from "../grid";

// TODO - this component doesn't actually wrap a info-table in a card... what is it really for?
@Component({
    selector: "info-table-card",
    templateUrl: "./infoTableCard.tmpl.html",
    standalone: false
})
export class InfoTableCardComponent
{
    @Input() readonly criteria: IInfoTableCriteria;
    @Input() readonly displayFooter: boolean;
    @Input() readonly hasParent: boolean;
    @Input() readonly hideHeader: boolean;

    //  TODO - change binding name to match field name.
    @Input("tableData") readonly infoTable: IInfoTable;
    @Output("tableDataChange") private readonly infoTableChange = new EventEmitter<IInfoTable>();

    @Input() readonly ignoreNumbers: boolean;
    @Input() readonly isFetching: boolean;
    @Input() readonly key: string;
    @Input() readonly noFilter: boolean;
    @Input() readonly rowsPerPage: number;

    @Input() readonly spaceForFab: boolean;
    @Input() readonly isSearchTable: boolean;
    @Input() readonly cardCommands: ReadonlyArray<Command>;
    @Input() readonly searchCommands: ReadonlyArray<Command>;
    @Input() readonly tableCommands: ReadonlyArray<Command>;
    @Input() readonly fireTableReload: Observable<void>;

    @Output("rowAction") readonly rowCustomAction = new EventEmitter<InfoGridRowActionEvent>();
    @Output() private readonly selectionChange = new EventEmitter<Array<string>>();
    @Output("clientAction") readonly tableCustomAction = new EventEmitter<InfoTableCommandArgs>();
    @Output() private readonly add = new EventEmitter<void>();
    @Output() private readonly editRow = new EventEmitter<EditRowArgs>();
    @Output() private readonly deleteRow = new EventEmitter<DeleteRowArgs>();
    @Output() private readonly reloadTableData = new EventEmitter<GetInfoTableOptions>();

    get displayHeader(): boolean { return !this.hideHeader; }
    get hasCommands(): boolean { return this.cardCommands?.length > 0; }
    get hasId(): boolean
    {
        // NOTE: Id maybe a number, and 0 is a valid value
        return !Utilities.IsNullOrUndefined(this.criteria?.Id);
    }

    get hasRowActions(): boolean { return EventEmitterHelper.hasSubscribers(this.rowCustomAction); }


    doClientAction($event: InfoTableCommandArgs): void
    {
        this.tableCustomAction.emit($event);
    }

    doRowAction($event: InfoGridRowActionEvent): void
    {
        this.rowCustomAction.emit($event);
    }

    onTableDataChange($event): void
    {
        this.infoTableChange.emit($event);
    }

    onSelectionChange($event: Array<string>): void
    {
        this.selectionChange.emit($event);
    }

    onAdd(): void
    {
        this.add.emit();
    }

    onEditRow($event: EditRowArgs): void
    {
        this.editRow.emit($event);
    }

    onDeleteRow($event: DeleteRowArgs): void
    {
        this.deleteRow.emit($event);
    }

    onReloadTableData($event: GetInfoTableOptions): void
    {
        this.reloadTableData.emit($event);
    }
}
